import React from "react";
import {SVGPATH} from '../svgDotPath'
import { Link } from "react-router-dom";

export const Header = ()=> {
    const dots = Array(4).fill(1)
    return <header class="py-5">
            <div class="container px-5 pb-5">
                <div class="row gx-5 align-items-center">

                    <div class="col-xxl-5">
                        {/* <!-- Header text content--> */}
                        <div class="text-center text-xxl-start">
                            <div class="badge bg-gradient-primary-to-secondary text-white mb-4"><div class="text-uppercase">Design &middot; Development &middot; Architecting</div></div>
                            <div class="fs-3 fw-light text-muted">I can help your business to</div>
                            <h1 class="display-3 fw-bolder mb-5"><span class="text-gradient d-inline">Get online and grow fast</span></h1>
                            <div class="d-grid gap-3 d-sm-flex justify-content-sm-center justify-content-xxl-start mb-3">
                                <Link className="btn btn-primary btn-lg px-5 py-3 me-sm-3 fs-6 fw-bolder" to="/resume">Resume</Link>
                                <Link class="btn btn-outline-dark btn-lg px-5 py-3 fs-6 fw-bolder" to="/projects">Projects</Link>
                            </div>
                        </div>
                    </div>

                    <div class="col-xxl-7">
                        {/* <!-- Header profile picture--> */}
                        <div class="d-flex justify-content-center mt-5 mt-xxl-0">
                            <div class="profile bg-gradient-primary-to-secondary">
                                <img class="profile-img" src="assets/profile.png" alt="..." />
                                {dots.map((v,i)=>(
                                 <div key={i} className={`dots-${i+1}`}>
                                    <SVGPATH/>
                                 </div>
                                ))}
                            </div>
                        </div>
                    </div>


                </div>
            </div>
</header>
}